export default __webpack_public_path__ + "static/landscapes-second-85aaeaf909a159f9d8897267845f5610.webp";